export default __webpack_public_path__ + "static/media/simplii.f155500c.jpeg";